import { Component, OnInit, OnDestroy } from '@angular/core';
import { SectorService } from '../../../@core/services/sector.service';
import { ApiProvider } from '../../../@core/providers/api.provider';
import { LocationService } from '../../../@core/services/location.service';
import { RouteCompress } from '../../../@core/models/live-route';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'locations-update',
  templateUrl: './locations-update.component.html',
  styleUrls: ['./locations-update.component.scss']
})
export class LocationsUpdateComponent implements OnInit, OnDestroy {
  public displayedColumns: string[] = ['Postal_Code', 'Route_ID', 'Priority'];
  public digitCount: number = 3;
  showLoading: boolean = false;
  sub: Subscription;
  selectedSectorId: number;
  admin: boolean = false;
  constructor(
    public apiProvider: ApiProvider,
    public _sectorService: SectorService,
    public _locationService: LocationService,
    public router: Router
  ) {
    if (this.router.url.endsWith('admin')) {
      this.admin = true;
    }
  }
  ngOnInit() {
    this.sub = this._locationService.loadingInProgress.subscribe((data) => {
      this.showLoading = data;
    });
  }

  public selectItem(tab: RouteCompress) {
    this._locationService.RouteID = tab.Route_ID;
    this._locationService.initialiseLocation(this.digitCount);
  }

  public connectedList: any[];

  getConnectedList(): any[] {
    if (this._sectorService.currentSectorValue != null) {
      this.connectedList = this._sectorService.currentSectorValue.RouteCompress.map(
        (x) => `${x.Route_ID}`
      );
      return this.connectedList.concat(['table']).concat(['tableOnHold']);
    } else {
      return null;
    }
  }

  public increase(): void {
    this._locationService.setLoadingInProgress(true);
    this.digitCount++;
    this._locationService.initialiseLocation(this.digitCount);
  }

  public decrease(): void {
    this._locationService.setLoadingInProgress(true);
    this.digitCount--;
    this._locationService.initialiseLocation(this.digitCount);
  }

  public updateRouteID(
    PostalCodeDigit: string,
    RouteID: number,
    Priority:number,
    PostalCode: string
  ): void {

    console.log("Priority", Priority);
    this.apiProvider
      .UpdateLocationRoute(
        this._locationService.RouteID,
        RouteID,
        Priority,
        PostalCodeDigit
      )
      .subscribe(() => {
        this._locationService.initialiseLocation(this.digitCount);
      });
  }

  dropCodePostal(event: CdkDragDrop<string[]>) {
    this.apiProvider
      .UpdateLocationPostalCode5Length(
        this._locationService.RouteID, //Old
        Number(event.container.id),
        event.item.data.PostalCode.substring(0, this.digitCount)
      )
      .subscribe((response) => {
        this._locationService.initialiseLocation(this.digitCount);
      });
  }

  zoomToMap(location: any) {
    location.zoom = 12;
    this._locationService.setLocation(location);
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
